import { render, staticRenderFns } from "./my_inbook_publication_data.vue?vue&type=template&id=3484527c"
import script from "./my_inbook_publication_data.vue?vue&type=script&lang=js"
export * from "./my_inbook_publication_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports